var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNombreDePersonne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 84 176",
    style: {
      enableBackground: "new 0 0 84 176"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#E5007E;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nb_personnes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,46.5c-11.9,0-21.6-9.7-21.6-21.6c0-11.9,9.7-21.6,21.6-21.6C54.4,3.3,64,13,64,24.9v0 C64,36.8,54.4,46.5,42.4,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.7,83.7v76.6c0,7.1-5.2,12.8-11.6,12.8c-6.4,0-11.6-5.7-11.6-12.8v-40.4v40.4c0,7.1-5.2,12.8-11.6,12.8 c-6.4,0-11.6-5.7-11.6-12.8V83.7l0.2,37h-2.6c-7.9,0-14.2-6.4-14.2-14.2V68.3c0-8.6,7-15.6,15.6-15.6h48.5c8.6,0,15.6,7,15.6,15.6 v38.2c0,7.9-6.4,14.2-14.2,14.2h-2.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNombreDePersonne);
export default __webpack_public_path__ + "static/media/nombre-de-personne.48b13b1c25efe39bed9f1b428839af81.svg";
export { ForwardRef as ReactComponent };